 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Account":"Account","AddCashier":"AddCashier","AddEditStatute":"AddEditStatute","AddShoppingCenterserList~EditShoppingCenterserList":"AddShoppingCenterserList~EditShoppingCenterserList","AddShoppingCenterserList":"AddShoppingCenterserList","EditShoppingCenterserList":"EditShoppingCenterserList","AddUser":"AddUser","CashierList":"CashierList","CashierOrders~ClickCollect~Customers~Orders~Statistics~UserList":"CashierOrders~ClickCollect~Customers~Orders~Statistics~UserList","CashierOrders~Customer~Logs~Orders":"CashierOrders~Customer~Logs~Orders","CashierOrders":"CashierOrders","Orders":"Orders","ClickCollect":"ClickCollect","Customers":"Customers","Statistics":"Statistics","UserList":"UserList","Customer":"Customer","Logs":"Logs","CashierOrder~Order":"CashierOrder~Order","CashierOrder":"CashierOrder","Order":"Order","Delivery":"Delivery","GlobalLayout":"GlobalLayout","Login":"Login","ResetPassword":"ResetPassword","ShoppingCenters":"ShoppingCenters","Statute":"Statute","Stock":"Stock","pickup":"pickup"}[chunkId]||chunkId) + "." + {"Account":"0bf1f9b7","AddCashier":"6b0b242a","AddEditStatute":"403d42ed","AddShoppingCenterserList~EditShoppingCenterserList":"63ba4448","AddShoppingCenterserList":"9e67a3c2","EditShoppingCenterserList":"21443ee9","AddUser":"5f66f048","CashierList":"f560714d","CashierOrders~ClickCollect~Customers~Orders~Statistics~UserList":"36f6027a","CashierOrders~Customer~Logs~Orders":"ed663fa1","CashierOrders":"986aa4ae","Orders":"30d68b86","ClickCollect":"86a30cc7","Customers":"ea1c3a14","Statistics":"e003c13f","UserList":"7403c9b1","Customer":"3abe5114","Logs":"de77ff17","CashierOrder~Order":"3375d11d","CashierOrder":"a4be089e","Order":"d114f68b","Delivery":"29dc9bed","GlobalLayout":"5c9546c4","Login":"229cae1e","ResetPassword":"69c78ce5","ShoppingCenters":"c50417d2","Statute":"9414e52f","Stock":"7402599f","chunk-2d0b59b6":"86098550","chunk-2d0e4ca0":"abb697e5","pickup":"b17fd9b6"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Account":1,"AddCashier":1,"AddEditStatute":1,"AddShoppingCenterserList~EditShoppingCenterserList":1,"EditShoppingCenterserList":1,"AddUser":1,"CashierList":1,"CashierOrders~ClickCollect~Customers~Orders~Statistics~UserList":1,"CashierOrders~Customer~Logs~Orders":1,"CashierOrders":1,"Orders":1,"Customers":1,"Statistics":1,"UserList":1,"Customer":1,"Logs":1,"CashierOrder~Order":1,"CashierOrder":1,"Delivery":1,"Login":1,"ResetPassword":1,"ShoppingCenters":1,"Statute":1,"Stock":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Account":"Account","AddCashier":"AddCashier","AddEditStatute":"AddEditStatute","AddShoppingCenterserList~EditShoppingCenterserList":"AddShoppingCenterserList~EditShoppingCenterserList","AddShoppingCenterserList":"AddShoppingCenterserList","EditShoppingCenterserList":"EditShoppingCenterserList","AddUser":"AddUser","CashierList":"CashierList","CashierOrders~ClickCollect~Customers~Orders~Statistics~UserList":"CashierOrders~ClickCollect~Customers~Orders~Statistics~UserList","CashierOrders~Customer~Logs~Orders":"CashierOrders~Customer~Logs~Orders","CashierOrders":"CashierOrders","Orders":"Orders","ClickCollect":"ClickCollect","Customers":"Customers","Statistics":"Statistics","UserList":"UserList","Customer":"Customer","Logs":"Logs","CashierOrder~Order":"CashierOrder~Order","CashierOrder":"CashierOrder","Order":"Order","Delivery":"Delivery","GlobalLayout":"GlobalLayout","Login":"Login","ResetPassword":"ResetPassword","ShoppingCenters":"ShoppingCenters","Statute":"Statute","Stock":"Stock","pickup":"pickup"}[chunkId]||chunkId) + "." + {"Account":"5b421bae","AddCashier":"5b421bae","AddEditStatute":"41db5755","AddShoppingCenterserList~EditShoppingCenterserList":"70842784","AddShoppingCenterserList":"31d6cfe0","EditShoppingCenterserList":"2cc99d89","AddUser":"5b421bae","CashierList":"df976b60","CashierOrders~ClickCollect~Customers~Orders~Statistics~UserList":"d3cc507e","CashierOrders~Customer~Logs~Orders":"929af710","CashierOrders":"0b94f07b","Orders":"e79726c3","ClickCollect":"31d6cfe0","Customers":"2cc99d89","Statistics":"0b94f07b","UserList":"51e00d92","Customer":"5b421bae","Logs":"006f9fec","CashierOrder~Order":"5f8b427f","CashierOrder":"26499d03","Order":"31d6cfe0","Delivery":"bcad4343","GlobalLayout":"31d6cfe0","Login":"5b421bae","ResetPassword":"5b421bae","ShoppingCenters":"df976b60","Statute":"006f9fec","Stock":"aad6b901","chunk-2d0b59b6":"31d6cfe0","chunk-2d0e4ca0":"31d6cfe0","pickup":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
